import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Typography from "@mui/material/Typography";
import testimonials from "./Partner/testimonialsData";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from "./Footer";

const SeeAllTestimonial = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const color = ["#febfbd", "#fdddaa", "#b1e8ca"];
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <Typography
        variant="h2"
        component="h2"
        sx={{
          color: "blue",
          fontWeight: "bold",
          textAlign: "center",
          pt: 6,
          pb: 1,
          mx: "auto",
        }}
      >
        Success Stories
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{
          color: "black",
          textAlign: "justify",
          pt: 1,
          pb: 3,
          lineHeight: 1.2,
          m: "auto",
          maxWidth: "1100px",
        }}
      >
        Read the{" "}
        <a
          href="https://www.iitmaa.org/f/mock-interview-12582"
          className="font-semibold underline text-blue-600 hover:text-blue-800"
        >
          Blog Article
        </a>{" "}
        on the role of Fyzen Career Solutions Pvt Ltd (creator of interwiu.com)
        in the success of below students by conducting Mock Interviews (with
        Feedback Sessions) before the Campus Placements (2021-22) at IIT Madras:
        published by <b> IIT Madras Alumni Association</b>
      </Typography>
      {testimonials.map((testimonial, index) => {
        return (
          <div className="my-5 mx-auto">
            <div
              className="text-black rounded-lg bg-white p-3 grid grid-cols-4 gap-3 mx-auto"
              style={{ width: "1100px", backgroundColor: color[index % 3] }}
              key={index}
            >
              <div className="col-span-1 my-auto ">
                <div
                  className="rounded-3xl m-3 mx-auto overflow-hidden"
                  style={{ height: "169px", width: "169px" }}
                >
                  <img
                    src={require("../../images/testimonial-image/" +
                      testimonial.name +
                      ".jpg")}
                    className="object-cover"
                    alt="Person"
                  />
                </div>
                <div className="text-center">
                  <Typography
                    variant="h5"
                    component="h5"
                    sx={{ fontWeight: "bold" }}
                  >
                    {testimonial.name}
                  </Typography>
                  {/* <p>
                            Place at {testimonial.company} as {testimonial.position}
                          </p> */}
                </div>
              </div>
              <div className="col-span-3 my-auto">
                <Typography
                  variant="body1"
                  sx={{ m: 0, fontSize: "18px" }}
                  gutterBottom
                >
                  {testimonial.degree} <b>IIT Madras</b>, 2022
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: "18px" }}
                  gutterBottom
                >
                  Placed at <b>{testimonial.placedIn}</b> as{" "}
                  <b>{testimonial.position}</b>
                </Typography>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{
                    textAlign: "justify",
                    lineHeight: 1.2,
                    mt: 2,
                  }}
                >
                  <i class="fa-solid fa-quote-left text-red-400"></i>{" "}
                  {testimonial.comment}{" "}
                  <i class="fa-solid fa-quote-right text-red-400"></i>
                </Typography>
              </div>
            </div>
          </div>
        );
      })}
      <Footer />
    </>
  );
};

export default SeeAllTestimonial;
